import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = ({ onLogout, onEmployeeLogout, userAccess, employeeSession }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const activeTab = location.pathname.split('/')[1] || 'pos';

  const handleTabClick = (tab) => {
    navigate(`/${tab}`);
    setIsMenuOpen(false);
  };

  const getButtonClass = (tab) =>
    `block w-full text-left px-4 py-2 text-sm rounded-md ${
      activeTab === tab
        ? 'bg-[#3F1907] text-[#F9EFD7] font-bold'
        : 'text-[#3F1907] hover:bg-gray-200'
    }`;

  return (
    <nav className="bg-gradient-to-r from-[#58735A] to-[#3F1907] shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">

          {/* Logo */}
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <img
                src="https://4tsix0yujj.ufs.sh/f/2vMRHqOYUHc0UPtKdi4lpN4OwGAX7ky90Ihqt2Z5MKWHdTfQ"
                alt="Logo POS"
                className="h-8"
              />
            </div>
          </div>

          <div className="flex items-center space-x-4">

            {/* 🔥 Empleado activo */}
            {employeeSession && (
              <div className="flex items-center space-x-2">
                <span className="text-[#F9EFD7] text-sm">
                  👤 {employeeSession.name}
                  <span className="ml-1 text-xs opacity-70">({employeeSession.role})</span>
                </span>
                <button
                  onClick={onEmployeeLogout}
                  className="text-xs text-[#F9EFD7] border border-[#F9EFD7] border-opacity-50 px-2 py-1 rounded hover:bg-white hover:bg-opacity-10 transition"
                >
                  Cambiar
                </button>
              </div>
            )}

            {/* Menú dropdown */}
            <div className="relative">
              <button
                onClick={toggleMenu}
                className="text-[#F9EFD7] hover:text-white focus:outline-none"
              >
                <span className="mr-2">Menú</span>
                <svg
                  className="h-6 w-6 inline-block"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>

              {isMenuOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-[#F9EFD7] rounded-md shadow-lg py-1 z-50">

                  {userAccess?.pos && (
                    <button onClick={() => handleTabClick('pos')} className={getButtonClass('pos')}>
                      Punto de Venta
                    </button>
                  )}
                  {userAccess?.comandas && (
                    <button onClick={() => handleTabClick('comandas')} className={getButtonClass('comandas')}>
                      Comandas
                    </button>
                  )}
                  {userAccess?.admin && (
                    <button onClick={() => handleTabClick('admin')} className={getButtonClass('admin')}>
                      Admin
                    </button>
                  )}
                  {userAccess?.menu && (
                    <button onClick={() => handleTabClick('menu')} className={getButtonClass('menu')}>
                      Menú
                    </button>
                  )}
                  {userAccess?.supplies && (
                    <button onClick={() => handleTabClick('supplies')} className={getButtonClass('supplies')}>
                      Insumos
                    </button>
                  )}
                  {userAccess?.sales && (
                    <button onClick={() => handleTabClick('sales')} className={getButtonClass('sales')}>
                      Ventas
                    </button>
                  )}
                  {userAccess?.costing && (
                    <button onClick={() => handleTabClick('costing')} className={getButtonClass('costing')}>
                      Costeo
                    </button>
                  )}
                  {userAccess?.analysis && (
                    <button onClick={() => handleTabClick('analysis')} className={getButtonClass('analysis')}>
                      Análisis
                    </button>
                  )}
                  {userAccess?.costStructure && (
                    <button onClick={() => handleTabClick('costStructure')} className={getButtonClass('costStructure')}>
                      Estructura de Costos
                    </button>
                  )}
                  {userAccess?.inventory && (
                    <button onClick={() => handleTabClick('inventory')} className={getButtonClass('inventory')}>
                      Inventario
                    </button>
                  )}
                  {userAccess?.dashboard && (
                    <button onClick={() => handleTabClick('dashboard')} className={getButtonClass('dashboard')}>
                      Dashboard
                    </button>
                  )}
                  {userAccess?.ticketSettings && (
                    <button onClick={() => handleTabClick('ticketSettings')} className={getButtonClass('ticketSettings')}>
                      Configuración Ticket
                    </button>
                  )}
                  {userAccess?.employees && (
                    <button onClick={() => handleTabClick('employees')} className={getButtonClass('employees')}>
                      Empleados
                    </button>
                  )}

                  <div className="border-t border-gray-200 my-1"></div>

                  <button
                    onClick={onLogout}
                    className="block w-full text-left text-[#3F1907] hover:bg-gray-200 px-4 py-2 text-sm rounded-md"
                  >
                    Cerrar Sesión
                  </button>

                </div>
              )}
            </div>
          </div>

        </div>
      </div>
    </nav>
  );
};

export default Navbar;